import CoordinatorDashboard from '../features/chat/components/CoordinatorDashboard';

export default function Dashboard() {
  return <CoordinatorDashboard />;
}
